import React, { FunctionComponent, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
// import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

import { fetch_one } from "../../../lib/v31lib";
// import { loginAtom } from '../../../lib/auth';

// import Lenis from "lenis";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { gsap } from "gsap";

// @ts-ignore
// import HeroImg from "../../../img/newest_additions/warme_welkom_maand1.png";

import {
  Box,
  Grid,
} from '@mui/material';
// import {
//   WhiteSection
// } from '../../../components/v2/custom';
import {
  DarkGreenButton,
  IconButton,
  LightGreenButton,
  Page,
  TextButton,
  Typography,
} from '../../../components/v2/styled';
import { Hero, WhiteSection } from '../../../components/v2/custom';

// import { Benefit as Ben } from '../../models/Benefit';
// import { NewsItem as NI } from '../../models/NewsItem';
import { User } from '../../../models/User';
import { Vennr } from '../../../components/v2/styled/Vennr';
import { Birthdate } from '../../../components/v2/styled/Birthdate';
import { OtpCode } from '../../../components/v2/styled/OtpCode';
import { ContentCopy } from '@mui/icons-material';

const { DateTime } = require("luxon");

type Props = {
  
}

export const RedeemWarmeWelkomMaand: FunctionComponent<Props> = ({}) => {
  // const [login, setLogin] = useAtom(loginAtom);
  const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);
  
  const [vennr, setVennr] = useState<string>('');
  const [birthdate, setBirthdate] = useState<string>('');
  const [otp, setOtp] = useState<string>('');
  const [showOtp, setShowOtp] = useState<boolean>(false);
  const [user, setUser] = useState<User>({
    id: undefined,
    auth_token: '',
    email: '',
    gender: 'M'
  });
  const [showError, setShowError] = useState<boolean>(false);
  const [error, setError] = useState<string>();
  const [benCode, setBenCode] = useState<string>();
  const [benPin, setBenPin] = useState<string>();









  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
      step: number;
    }) => {
      return fetch_one<{
        custom_result: any
      }>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/custom_action`,
        pars.formData,
        undefined
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      console.log(data);

      setShowOtp(false);
      setShowError(false);
      setError(undefined);

      if (variables.step === 1) {
        if (!!data.custom_result.mfa_status_0_verification) {
          setShowOtp(true);
        } else {
          if (!data.custom_result.message) {
            setUser({
              id: data.custom_result.id,
              first_name: data.custom_result.first_name,
              last_name: data.custom_result.last_name,
              vennoot_number: data.custom_result.vennoot_number,
              email: '',
              auth_token: ''
            });
            // setSubStep(13);
          } else {
            setError(data.custom_result.message);
            setShowError(true);
          }
        }
      }

      if (!!data.custom_result.error) {
        setShowError(true);
        setError(data.custom_result.error);
      }

      if (!!data.custom_result.benefit_code) {
        setBenCode(data.custom_result.benefit_code);
      }

      if (!!data.custom_result.benefit_pin) {
        setBenPin(data.custom_result.benefit_pin);
      }

      if (!!data.custom_result.user) {
        setUser({
          ...data.custom_result.user,
          birth_date: DateTime.fromISO(data.custom_result.user?.birth_date).toFormat("dd/LL/y")
        });
      }
    },
  });








  
  return <Page>
    <Hero
      // picLeft={HeroImg}
      children={<>
        <Typography variant="h1" html fuck_p_tags sx={{
          maxWidth: {
            xs: '100%',
            lg: '670px'
          },
          textAlign: 'center',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}>{t("nw.redeem.warme_welkom_maand.title")}</Typography>
        <Typography variant="subtitle1" html fuck_p_tags sx={{
          color: theme.palette.primary.dark,
          marginTop: 4,
          maxWidth: {
            xs: '100%',
            lg: '670px'
          },
          textAlign: 'center',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}>{t("nw.redeem.warme_welkom_maand.subtitle")}</Typography>
      </>}
    />
    
    <WhiteSection isTransparent sx={{
      "& > div > div": {
        padding: 0
      },
      "& > div > div > div > div": {
        minHeight: 20,
        height:'auto'
      }
    }}>
      <Grid container spacing={1} sx={{
        width: {
          xs: '100%',
          lg: '900px'
        },
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: 4
      }}>
        {!!showError && <>
          <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
            <Typography variant="subtitle1" html fuck_p_tags sx={{
              display: 'inline-block',
              // color: theme.palette.warning.main
            }}>{t(error || '')}</Typography>
          </Grid>
          <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
            <TextButton
              id="back_btn"
              label={t("nw.emission.forgot.cta_back")}
              onClick={() => {
                setShowError(false);
                // setTimeout(() => {lenis.scrollTo(0);}, 200);
              }}
              sx={{
                marginLeft: 1,
                marginRight: 1,
                marginTop: 1
              }}
            />
          </Grid>
        </>}
        {/* {!!showSuccess && <>
          <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
            <Typography variant="subtitle1" html fuck_p_tags sx={{
              display: 'inline-block',
              color: theme.palette.primary.light
            }}>{t("nw.gifts.confirmed_awaiting_argenco")}</Typography>
          </Grid>
          <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
            <TextButton
              id="back_btn"
              label={t("nw.emission.forgot.cta_back")}
              onClick={() => {
                setShowError(false);
                // setTimeout(() => {lenis.scrollTo(0);}, 200);
              }}
              sx={{
                marginLeft: 1,
                marginRight: 1,
                marginTop: 1
              }}
            />
          </Grid>
        </>} */}

        {!user?.id && !showError && <>
          <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
            <Box sx={{
              display: 'inline-block',
              width: {
                xs: '100%',
                lg: '440px'
              },
              textAlign: 'left'
            }}>
              <Vennr
                value={vennr || ''}
                onChange={(v) => {
                  setVennr(v.target.value);
                }}
                starred
                caption={t("nw.register.form.lidnummer")}
                // error={(!!vennr && vennr[0].toUpperCase() !== "B") ? t("nw.redeem.warme_welkom_maand.error.not_for_a") : undefined}
                // placeholder={t("nw.contact.form.placeholder.first_name")}
                sx={{
                  borderRadius: "8px",
                  width: '100%',
                  border: "2px solid transparent",
                  borderColor: theme.palette.primary.dark,
                  paddingTop: 0.25,
                  paddingBottom: 0.25,
                  height: '40px',
                  backgroundColor: 'transparent'
                }}
              />
              {(!!vennr && vennr[0].toUpperCase() !== "B") && <Box sx={{width: '100%', height: '1px'}}></Box>}
              <Birthdate
                value={birthdate || ''}
                hideError={(birthdate || '_').indexOf("_") > -1}
                onChange={(v) => {
                  setBirthdate(v.target.value);
                }}
                starred
                caption={t("nw.user_info.birth_date")}
                // placeholder={t("nw.contact.form.placeholder.first_name")}
                sx={{
                  borderRadius: "8px",
                  width: '100%',
                  border: "2px solid transparent",
                  borderColor: theme.palette.primary.dark,
                  paddingTop: 0.25,
                  paddingBottom: 0.25,
                  height: '40px',
                  backgroundColor: 'transparent',
                }}
              />
              {!!showOtp && <OtpCode
                value={otp || ''}
                onChange={(v) => {
                  setOtp(v.target.value);
                }}
                starred
                caption={t("nw.public.otp_code")}
                sx={{
                  borderRadius: "8px",
                  width: '100%',
                  border: "2px solid transparent",
                  borderColor: theme.palette.primary.dark,
                  paddingTop: 0.25,
                  paddingBottom: 0.25,
                  height: '40px',
                  backgroundColor: 'transparent',
                }}
              />}
            </Box>
          </Grid>
          <Grid item xs={12} sx={{textAlign: 'right', marginBottom: 8}}>
            <Box sx={{
              display: 'block',
              width: '100%',
              maxWidth: {
                xs: '100%',
                lg: '440px'
              },
              marginTop: 2,
              marginRight: 'auto',
              marginLeft: 'auto',
              textAlign: 'right'
            }}>
              <Box sx={{
                display: 'inline-block',
                width: {
                  xs: '100%',
                  lg: '49%'
                },
                textAlign: 'left',
                float: 'left'
              }}>
                <TextButton
                  label={t("nw.emission.forgot.cta_back")}
                  id="sub_btn"
                  onClick={() => {
                    setOtp('');
                    // setTimeout(() => {lenis.scrollTo(0);}, 200);
                    navigate("/");
                  }}
                  sx={{
                    marginBottom: 1,
                    color: theme.palette.primary.dark,
                    textDecoration: 'underline',
                    "&:hover": {
                      color: theme.palette.primary.light,
                      backgroundColor: 'transparent'
                    },
                    paddingLeft: 0,
                    paddingRight: 0
                  }}
                />
              </Box>
              <Box sx={{
                display: 'inline-block',
                width: {
                  xs: '100%',
                  lg: '49%'
                },
                marginLeft: 'auto',
                textAlign: 'right'
              }}>
                <DarkGreenButton
                  label={t("nw.register.hero.cta")}
                  id="sub_btn"
                  sx={{
                    marginBottom: 1,
                    borderColor: theme.palette.primary.dark,
                    "&:hover": {
                      borderColor: theme.palette.primary.dark,
                      backgroundColor: theme.palette.primary.light,
                      color: theme.palette.primary.dark,
                    },
                    "&.Mui-disabled": {
                      color: 'grey',
                    },
                  }}
                  disabled={!vennr || (!!vennr && vennr[0].toUpperCase() !== "B") || !birthdate || !DateTime.fromFormat(birthdate, "dd/LL/y").isValid || (!!showOtp && !otp)}
                  onClick={() => {
                    mutationCustomAction.mutate({
                      formData: {
                        object: 'user',
                        class_action: 'custom_api_validate',
                        birthdate: birthdate,
                        vennr: vennr,
                        otp: otp.replace(" ", "").replace("_", ""),
                        basic_info: 1
                      },
                      step: 1
                    });
                  }}
                />
              </Box>
            </Box>
          </Grid>
        </>}
        {!!user?.id && <>
          {!benCode && <Grid item xs={12}>
            <Typography variant="subtitle1" html fuck_p_tags sx={{
              color: theme.palette.primary.dark,
              marginTop: 4,
              maxWidth: {
                xs: '100%',
                lg: '670px'
              },
              textAlign: 'center',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}>{t("nw.redeem.warme_welkom_maand.logged_in_explanation")}</Typography>
          </Grid>}

          {!!benCode && <Grid item xs={12}>
            <Typography variant="subtitle1" html fuck_p_tags sx={{
              color: theme.palette.primary.dark,
              marginTop: 4,
              maxWidth: {
                xs: '100%',
                lg: '670px'
              },
              textAlign: 'center',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}>{t("nw.redeem.warme_welkom_maand.logged_in_explanation_with_code", {code: benCode, pin: benPin})}</Typography>
          </Grid>}

          {!!benCode && <Grid item xs={12}>
            <Box sx={{
              padding: 1,
              border: '1px solid transparent',
              borderColor: theme.palette.primary.light,
              marginTop: 1,
              borderRadius: 1
            }}>
              <Typography variant="subtitle1" html fuck_p_tags sx={{
                color: theme.palette.primary.dark,
                maxWidth: {
                  xs: '100%',
                  lg: '670px'
                },
                textAlign: 'center',
                marginLeft: 'auto',
                marginRight: 'auto',
                fontSize: '1.3rem',
                fontWeight: 'bold'
              }}>{benCode} <IconButton
                onClick={(e) => {
                  e.preventDefault();
                  navigator.clipboard.writeText((benCode || '').replace(/<[^>]*>?/gm, ''));
                }}
                sx={{
                  marginLeft: 1
                }}
              ><ContentCopy color="primary" /></IconButton></Typography>
            </Box>
          </Grid>}

          {!!benPin && <Grid item xs={12}>
            <Box sx={{
              padding: 1,
              border: '1px solid transparent',
              borderColor: theme.palette.primary.light,
              marginTop: 1,
              borderRadius: 1
            }}>
              <Typography variant="subtitle1" html fuck_p_tags sx={{
                color: theme.palette.primary.dark,
                maxWidth: {
                  xs: '100%',
                  lg: '670px'
                },
                textAlign: 'center',
                marginLeft: 'auto',
                marginRight: 'auto',
                fontSize: '1.3rem',
                fontWeight: 'bold'
              }}>{benPin} <IconButton
                onClick={(e) => {
                  e.preventDefault();
                  navigator.clipboard.writeText((benPin || '').replace(/<[^>]*>?/gm, ''));
                }}
                sx={{
                  marginLeft: 1
                }}
              ><ContentCopy color="primary" /></IconButton></Typography>
            </Box>
          </Grid>}

          {!!benCode && <Grid item xs={12}>
            <Typography variant="subtitle1" html fuck_p_tags sx={{
              color: theme.palette.primary.dark,
              marginTop: 4,
              maxWidth: {
                xs: '100%',
                lg: '670px'
              },
              // textAlign: 'center',
              marginLeft: 'auto',
              marginRight: 'auto'
            }}>{t("nw.redeem.warme_welkom_maand.logged_in_explanation_with_code_steps", {code: benCode, pin: benPin})}</Typography>
          </Grid>}

          <Grid item xs={12} sx={{textAlign: 'right', marginBottom: 8}}>
            <Box sx={{
              display: 'block',
              width: '100%',
              maxWidth: {
                xs: '100%',
                lg: '440px'
              },
              marginTop: 2,
              marginRight: 'auto',
              marginLeft: 'auto',
              textAlign: 'right'
            }}>
              <Box sx={{
                display: 'inline-block',
                width: {
                  xs: '100%',
                  lg: '49%'
                },
                textAlign: 'left',
                float: 'left'
              }}>
                <TextButton
                  label={t("nw.emission.forgot.cta_back")}
                  id="sub_btn"
                  onClick={() => {
                    setUser({
                      id: undefined,
                      auth_token: '',
                      email: '',
                      gender: 'M'
                    });
                    // setTimeout(() => {lenis.scrollTo(0);}, 200);
                  }}
                  sx={{
                    marginBottom: 1,
                    color: theme.palette.primary.dark,
                    textDecoration: 'underline',
                    "&:hover": {
                      color: theme.palette.primary.light,
                      backgroundColor: 'transparent'
                    },
                    paddingLeft: 0,
                    paddingRight: 0
                  }}
                />
              </Box>
              <Box sx={{
                display: !!benCode ? 'none' : 'inline-block',
                width: {
                  xs: '100%',
                  lg: '49%'
                },
                marginLeft: 'auto',
                textAlign: 'right'
              }}>
                <DarkGreenButton
                  label={t("nw.register.hero.redeem")}
                  id="sub_btn"
                  sx={{
                    marginBottom: 1,
                    borderColor: theme.palette.primary.dark,
                    "&:hover": {
                      borderColor: theme.palette.primary.dark,
                      backgroundColor: theme.palette.primary.light,
                      color: theme.palette.primary.dark,
                    },
                    "&.Mui-disabled": {
                      color: 'grey',
                    },
                  }}
                  disabled={mutationCustomAction?.isPending}
                  onClick={() => {
                    mutationCustomAction.mutate({
                      formData: {
                        object: 'user',
                        class_action: 'custom_api_redeem_wwm',
                        user_id: user?.id
                      },
                      step: 2
                    });
                  }}
                />
              </Box>
            </Box>
          </Grid>
        </>}

      </Grid>
    </WhiteSection>
  </Page>;
}
